export default __webpack_public_path__ + "static/media/Head_4_Ear_1_C2.fcbdd110.svg";